<template>
  <div
    class="badge-status text-status"
    v-bind:class="
      getBadgeStatusClass(
        stage,
        status,
        createdAt,
        updateStatus,
        pickupDate,
        timezone
      )
    "
  >
    {{ getBadgeStatusLabel(stage, status, updateStatus) }}
  </div>
</template>

<script>
import moment from "moment-timezone";
export default {
  name: "TransferStatusBadge",
  props: {
    stage: {
      type: String,
      required: true
    },
    status: {
      type: String,
      required: true
    },
    updateStatus: {
      type: Boolean,
      default: false
    },
    pickupDate: {
      type: String,
      default: ""
    },
    createdAt: {
      type: String,
      default: ""
    },
    timezone: {
      type: String,
      default: ""
    }
  },
  methods: {
    getBadgeStatusClass(
      stage,
      status,
      createdAt,
      statusUpdate,
      pickupDate,
      timeZone
    ) {
      if (stage === "QUOTE") {
        return this.quoteCssClass(status);
      }

      return this.reservationCssClass(
        status,
        createdAt,
        statusUpdate,
        pickupDate,
        timeZone
      );
    },
    getBadgeStatusLabel(stage, status, statusUpdate) {
      if (stage === "QUOTE") {
        return this.quoteLabel(status);
      }
      return this.reservationLabel(status, statusUpdate);
    },
    reservationCssClass(status, createdAt, statusUpdate, pickupDate, timeZone) {
      if (status === "NW") {
        let cutOff = this.isWithin72Hours(pickupDate, timeZone);
        let diff = this.getDifference(createdAt) >= 48;
        return this.getStatusClassForNewStatus(cutOff, diff, statusUpdate);
      } else if (status === "SC") {
        let cutOff = this.isWithin72Hours(pickupDate, timeZone);
        return this.getStatusClassForConfirmedStatus(cutOff, statusUpdate);
      } else if (["SCB", "SBC"].includes(status)) {
        return "status-cancelled";
      } else if (status === "SRB") {
        let cutOff = this.isWithin72Hours(pickupDate, timeZone);
        return cutOff ? "status-rejected critical-rejected" : "status-rejected";
      } else if (["DA", "DSR", "DAP", "POB"].includes(status)) {
        return "status-started";
      } else if (status === "JF") {
        return "status-completed";
      } else if (status === "NS") {
        return "status-noshow";
      } else if (status === "BI") {
        return "status-draft";
      } else if (status === "PNDG") {
        return "status-draft";
      } else if (status === "EXPIRED") {
        return "status-expired";
      } else {
        return {};
      }
    },
    reservationLabel(status, statusUpdate) {
      if (status === "SC") {
        return statusUpdate
          ? "Reconfirm"
          : this.getReservationStatusFormat(status);
      }
      return this.getReservationStatusFormat(status);
    },
    getStatusClassForNewStatus(cutOff, diff, statusUpdate) {
      if (cutOff) {
        if (diff) {
          return "status-overdue critical-overdue";
        } else {
          return statusUpdate
            ? "status-reconfirm critical-reconfirm"
            : "status-new critical-new";
        }
      } else {
        if (diff) {
          return "status-overdue";
        } else {
          return statusUpdate ? "status-reconfirm" : "status-new";
        }
      }
    },
    getStatusClassForConfirmedStatus(cutOff, statusUpdate) {
      if (statusUpdate) {
        return cutOff
          ? "status-reconfirm critical-reconfirmed"
          : "status-reconfirm";
      } else {
        return "status-confirmed";
      }
    },
    isWithin72Hours(pickupDate, timeZone) {
      let currentDate = moment.tz(timeZone).utc(true);
      let thresholdDate = moment(pickupDate).subtract(72, "hours");
      return (
        currentDate.isAfter(thresholdDate) && currentDate.isBefore(pickupDate)
      );
    },
    getDifference(createdAt) {
      return moment(moment().format()).diff(
        moment(createdAt).format(),
        "hours",
        true
      );
    },
    getReservationStatusFormat(status) {
      if (status === "NW") {
        return "New";
      } else if (status === "SBC" || status === "SCB") {
        return "Cancelled";
      } else if (status === "SC") {
        return "Confirmed";
      } else if (status === "JF") {
        return "Completed";
      } else if (status === "SRB") {
        return "Rejected";
      } else if (status === "DA") {
        return "Driver Accepted";
      } else if (status === "DSR") {
        return "Driver Started Trip";
      } else if (status === "DAP") {
        return "Driver on Location";
      } else if (status === "POB") {
        return "POB";
      } else if (status === "NS") {
        return "No Show";
      } else if (status === "PNDG") {
        return "Pending Payment";
      } else if (status === "EXPIRED") {
        return "Expired";
      }
      return "Draft";
    },
    quoteLabel(status) {
      if (status === "NEW") {
        return "Processing";
      } else if (status === "DRAFT") {
        return "Draft";
      } else if (status === "CANCELLED") {
        return "Cancelled";
      } else if (status === "EXPIRED") {
        return "Expired";
      } else if (status === "REJECTED") {
        return "Rejected";
      }
      return "Unknown Status";
    },
    quoteCssClass(status) {
      if (status === "NEW") {
        return "status-processing";
      } else if (status === "CANCELLED") {
        return "status-cancelled";
      } else if (status === "DRAFT") {
        return "status-draft";
      } else if (status === "EXPIRED") {
        return "status-expired";
      } else if (status === "REJECTED") {
        return "status-rejected";
      }
      return {};
    }
  }
};
</script>
